export default "__VITE_ASSET__6c987da3__"